<template>
  <v-container fluid class="py-0" :style="'height:' + computedPageHeight + 'px'">

    <v-row>
      <v-col
        class="pa-0">

        <!-- on image bar -->
        <v-row class="carousel-top-element white--text">
          <v-col class="py-0 max-width-1200 mx-auto">
            <app-bar-menu
              component="EnergyMonitor"
              logo="dark"
              text="dark"
              class="font-border">
            </app-bar-menu>
          </v-col>
        </v-row>

        <!-- hero -->
        <v-card flat dark>
          <v-sheet
            :min-height="breakpoint ? '' : 750"
            :max-height="computedCarouselHeight"
            :style="'height:' + computedCarouselHeight + 'px'"
            color="grey lighten-2"
            dark
            tile>

            <!-- TODO wrap on small display -->
            <v-row
              class="fill-height max-width-1200 mx-auto black--text"
              align="center"
              justify="center">
              <v-col cols="12" md="6" lg="6" class="mt-12 mt-md-0">
                <v-row>
                  <v-col class="text-start">
                    <span class="product-brand">{{$t("rubin.rubin")}}</span><br>
                    <span class="product-name">{{ $t('energyManagement.service.energyMonitor.2.title') }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-icon
                      v-for="(item,index) in energyTypes"
                      :key="index"
                      light
                      class="pr-4">
                        {{ item.icon }}
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row
                  v-for="(item,index) in pros"
                  :key="index"
                  class="pros-not-showing-on-mobile">
                  <v-col class="text-start product-pro border-bottom-dark">
                    {{ $t(item.short) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" lg="6" class="mockup-wrapper">
                <div class="mockup-div">
                  <img
                    src="@/assets/em/em_mockup_00b.png"
                    alt="Rubin Monitor program képe"
                    class="mockup-img">
                </div>
              </v-col>
            </v-row>
            <!-- landing scroll menu -->
            <v-row class="menu landing-scroll">
              <v-col class="max-width-1200 px-0 mx-auto">
                <v-btn
                  id="back" name="back" title="back"
                  text light
                  @click="loadPage('EnergyManagement')">
                    <v-icon>
                      mdi-chevron-double-left
                    </v-icon>
                </v-btn>
                <v-btn
                  v-for="(item,index) in sections"
                  :key="index"
                  text light
                  @click="scrollTOSection(item.id)">
                    {{ $t(item.title) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-sheet>

        </v-card>

        <v-row class="mx-1">
          <v-col id="about">
            <About></About>
          </v-col>
        </v-row>
        <v-row class="mx-0 bg-grey-light">
          <v-col id="process">
            <Process></Process>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col id="software">
            <Software></Software>
          </v-col>
        </v-row>
        <v-row class="mx-0 bg-grey-light">
          <v-col id="cost">
            <Cost></Cost>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col id="studies">
            <Studies></Studies>
          </v-col>
        </v-row>
        <v-row class="mx-0 bg-ruby">
          <v-col id="contact">
            <Contact></Contact>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

    <v-dialog
      v-model="$store.getters.energyMonitorDeDialog"
      class="energyMonitorDeDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar
          dark
          color="primary">
          <v-card
            flat color="transparent" dark
            :ripple="false"
            class="d-flex"
            style="min-width:210px;"
            @click="loadPage('Home')">
            <span><img
              src="@/assets/logo-flat-light.svg"
              loading="lazy"
              class="shrink mr-2"
              contain
              alt="Rubin Infomatika logó"
              transition="scale-transition"
              height="24" width="24"></span>
            <span class="brand-title pr-2" style="margin-top:2px;" :style="'color: #000000;'">{{ $t('rubin.rubin') }}</span>
            <span class="brand-subtitle"   style="margin-top:8px;" :style="'color: #000000;'">{{ $t('rubin.informatic') }}</span>
          </v-card>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="setLangDe(false)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid class="overflow-y" :style="'height:' + computedPageHeight - 64 + 'px'">
          <v-row
              class="fill-height max-width-1200 mx-auto black--text"
              align="center"
              justify="center">
            <v-col cols="12">

              <v-row justify="center">
                <v-col class="display-4">
                  Rubin Energiemonitor
                </v-col>
              </v-row>
              <v-row>
                <v-col class="display-1 primary--text">
                  Für Fachleute im Bereich Energie- und Gebäudemanagement sowie<br>
                  für Führungskräfte im Bereich Umweltschutz und Finanzen
                </v-col>
              </v-row>
              <v-row>
                <v-col class="align-center d-flex">
                  <v-img
                    src="@/assets/em/em_mockup_03.png"
                    contain
                    class="mx-auto"
                    style="width: calc(100% - 48px);">
                  </v-img>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-row
                    v-for="(item, index) in energyMonitorDe.list"
                    :key="index"
                    class="pl-4">
                    <v-col style="max-width: 50px">
                      <v-icon
                        color="primary">
                        mdi-play
                      </v-icon>
                    </v-col>
                    <v-col class="headline">
                      {{ item }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="my-4 align-center d-flex">
                  <v-img
                    src="@/assets/em/em_mockup_04.png"
                    contain
                    class="mx-auto"
                    style="width: calc(100% - 48px);">
                  </v-img>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-row>
                    <v-col class="display-1">
                      Referenzen, partner
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12" sm="6" md="4"
                      v-for="(item, index) in energyMonitorDe.reference"
                      :key="index"
                      class="py-2 caption">
                      {{ item }}
                    </v-col>
                  </v-row>
                  <v-row justify="center" class="mt-8">
                    <v-col style="display:contents;">
                      <div
                        v-for="(item,index) in energyMonitorDe.partners"
                        :key="index"
                        class="ma-4">
                          <img
                            :src="item.img"
                            loading="lazy"
                            :alt="item.name + 'logó'"
                            height="30"
                            style="object-fit:contain;">
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="mt-8 mx-0 bg-ruby">
                <v-col>
                </v-col>
                <v-col cols="12" sm="4" class="px-6">
                  <v-col class="justify-end text-end">
                    <img
                      src="@/assets/logo-flat-light.svg"
                      loading="lazy"
                      alt="Rubin Infomatika logó"
                      height="80" width="80">
                  </v-col>
                  <v-col class="pt-0">
                    <v-row>
                      <v-col class="pb-0 text-end caption text-uppercase">
                        Rubin Informatikai Zrt.
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0 pt-1 text-end caption">
                        1149 Budapest, Egressy út 17-21.
                      </v-col>
                    </v-row>
                    <!-- <v-row>
                      <v-col id="showPhoneNumber" class="pb-0 pt-1 text-end caption mouse-hover-link" @click="showPhoneNumber()">
                        {{ $t("common.showPhoneNumber") }}
                      </v-col>
                      <v-col id="phoneNumber" class="pb-0 pt-1 text-end caption mouse-hover-link" @click="openPhone('+3614694020')">
                        +36 1 469 40 20
                      </v-col>
                    </v-row> -->
                  </v-col>
                </v-col>
              </v-row>

            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import About from '@/components/EnergyManagement/EnergyMonitor/About.vue'
  import Process from '@/components/EnergyManagement/EnergyMonitor/Process.vue'
  import Software from '@/components/EnergyManagement/EnergyMonitor/Software.vue'
  import Cost from '@/components/EnergyManagement/EnergyMonitor/Cost.vue'
  import Studies from '@/components/EnergyManagement/EnergyMonitor/Studies.vue'
  import Contact from '@/components/Common/Contact.vue'


  export default {
    name: 'EnergyMonitor',
    metaInfo: {
      title: 'Energiamonitor',
      titleTemplate: '%s - Rubin Informatika',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Integrált szoftvermegoldás, fogyasztás, termelési adatait egy központi adatbázis'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'energiamenedzsment, energiamérés, almérés, energiamegtakarítás, teljesítménylekötés, épületfelügyelet, mérőeszközök, infrastruktúrafelügyelet'
        }
      ],
      __dangerouslyDisableSanitizers: ['meta'],
    },

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      About,
      Process,
      Software,
      Cost,
      Studies,
      Contact,
    },

    data: () => ({
      pros: [
        { title: "", short: "energyMonitor.pros.01.short", component: "",},
        { title: "", short: "energyMonitor.pros.02.short", component: "",},
        { title: "", short: "energyMonitor.pros.03.short", component: "",},
      ],
      energyTypes: [
        { icon: "mdi-flash" },
        { icon: "mdi-fire" },
        { icon: "mdi-water" },
        { icon: "mdi-thermometer" },
      ],
      sections: [
        { id: "about",          title: "common.about", },
        { id: "process",        title: "common.process", },
        { id: "software",       title: "common.software", },
        { id: "cost",           title: "common.cost", },
        { id: "studies",        title: "common.studies", },
      ],
      energyMonitorDe: {
        dialog: true,
        list: [
          "Zur Messung des Elektrizitäts-, Gas-und Wasserverbrauchs sowie der thermischen Energie",
          "Kenntnis des Verbraucherprofils",
          "Fernüberwachung",
          "Übermittlung von Daten – für Finanz- und Rechnungslegungssysteme",
          "Kostenaufteilung zwischen Mietern oder organisatorischen Einheiten",
          "Investitionsentscheidungen anhand entsprechender Daten",
        ],
        reference: [
          "Preis von Intel „Die innovativste PXA Entwicklung im Infrastrukturbetrieb”, 2005",
          "ISO 9001 Zertifizierung",
          "ISO 14001 Zertifizierung",
          "Seit 2007 qualifizierter (empfohlener) Lieferant der Kategorie „A“ der Ungarischen Telekom",
          "Oracle Certified Gold Partner",
          "Großer Ungarischer Innovationspreis, Niveaupreis: Klimatisierung mit Lüftung, 2008",
          "Großer Ungarischer Innovationspreis mit dem Produkt „PULSE”, 2009",
          "Mitglied des Ungarischen BioethanolVerbands, 2011",
          "KDRIK Mitglied des Akkreditierten Innovationsclusters im Rahmen des Neuen Széchenyi-Plans, 2011",
          "DELFIN-Preis, 2012",
          "Innomax Sonderpreis “Grüner Serverraum”, 2013",
          "Mitglied des Clusters Intelligente Zukunft, 2013",
          "“Energiebewusstes Unternehmen”, Virtuelles  Kraftwerk-Programm, 2014",
          "4Ausschreibung „Für das Energiebewusstsein der Unternehmen”, Kategorie Kleinunternehmen, Preis II, 2014",
          "Zertifizierung HUNGUARD für das System DOMINO, 2015",
          "DELFIN-Preis, 2015",
          "Leadership Award, 2015",
        ],
        partners: [
          { img: require("@/assets/partners/partner_antennahungaria.png"),     name: "Antenna Hungária"  },
          { img: require("@/assets/partners/partner_elmu.png"),                name: "Elmű"  },
          { img: require("@/assets/partners/partner_eon.png"),                 name: "EON"  },
          { img: require("@/assets/partners/partner_00_flextronics.png"),      name: "Flextronics International Kft."  },
          { img: require("@/assets/partners/partner_grafisoft.png"),           name: "Grafisoft"  },
          { img: require("@/assets/partners/partner_magyartelekom.png"),       name: "Magyar Telekom"  },
          { img: require("@/assets/partners/partner_vodafone.png"),            name: "Vodafone"  },
          { img: require("@/assets/partners/partner_00_nassmagnet.png"),       name: "Nass Magnet"  },
          // { img: require("@/assets/partners/partner_origostudios.png"),        name: "Origo"  },
        ],
      },
    }),

    mounted() {
    },

    computed: {
      breakpoint() {
        if (this.computedWidth < 961) {
          return true
        } else {
          return false
        }
      },
      computedCarouselHeight() {
        return this.styleProps.windowHeight;
      },
    },

    methods: {
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      }
    },

    watch: {
      // "$store.getters.langDe"() {
      //   console.log(this.$store.getters.energyMonitorDeDialog)
      //   this.energyMonitorDe.dialog = this.$store.getters.langDe;
      // }
    },
  }

</script>

<style src="../../Style.css">
</style>
